import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-covid-protection-transaction',
  templateUrl: './covid-protection-transaction.component.html',
  styleUrls: ['./covid-protection-transaction.component.css']
})
export class CovidProtectionTransactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
